/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M14.886 48l20.269-22.522L36.493 24l-1.338-1.478L14.886 0l-3.379 2.956L30.44 24 11.507 45.044z" fill-rule="nonzero"/>'
}
